import { Box, Img } from '@chakra-ui/react';
import { WSysLayout, WSysPreferences, useWSysPath } from "@coimbra-its/websys-ux-core";
import "@fontsource/montserrat";
import { Dashboard } from './features/Dashboard';
import { Wallet } from './features/Wallet';
import { useSunStore } from './store/sunSlice';
import { SunBlock } from './components/Sun';
import { PayoutSDBN3Plus } from './features/PayoutSDBN3Plus';
import { WithdrawSDBN3Plus } from './features/WithdrawSDBN3Plus';
import { PayoutSDBN3 } from './features/PayoutSDBN3';
import { WithdrawSDBN3 } from './features/WithdrawSDBN3';
import { useWSysAppkit } from './web3/web3';




export function App() {

	const path = useWSysPath();
	useWSysAppkit();

	const connectedWallet = useSunStore((state) => state.connectedWallet)
	const isLoading = useSunStore((state) => state.isLoading)

	const walletBox = <SunBlock py={3} {...!!connectedWallet && {header:'Connected wallet'}}>
			<w3m-button />
		</SunBlock>


	return <>
		<Box position='fixed' left='50px' top='44px' color='#fff'>
			<Img src='images/sunmoney_logo.png' w='121px' /><br />
		</Box>
		<WSysLayout >
			{path.on('wallet', <Wallet />)}
			{path.on('withdraw_sdbn3', <WithdrawSDBN3 />)}
			{/*path.on('withdraw_sdbn3plus', <WithdrawSDBN3Plus />)*/}
			{path.on('admin_payout_sdbn3', <PayoutSDBN3 />)}
			{/*path.on('admin_payout_sdbn3plus', <PayoutSDBN3Plus />)*/}
			{path.on('preferences', <WSysPreferences />, { group: 99 })}
			{path.elseOpen(<Dashboard walletBox={walletBox} />)}

		</WSysLayout>

	</>
}